import { GuideStatus } from "@mapmycustomers/shared";

// level1 = current status
// level2 = suggested guide status
// level3 = final status to use
const nextGuideStatusStateMachine: Record<GuideStatus, Record<GuideStatus, GuideStatus>> = {
  [GuideStatus.COMPLETED]: {
    [GuideStatus.COMPLETED]: GuideStatus.COMPLETED,
    [GuideStatus.NOT_STARTED]: GuideStatus.COMPLETED,
    [GuideStatus.PROGRESS]: GuideStatus.COMPLETED,
  },
  [GuideStatus.NOT_STARTED]: {
    [GuideStatus.COMPLETED]: GuideStatus.COMPLETED,
    [GuideStatus.NOT_STARTED]: GuideStatus.NOT_STARTED,
    [GuideStatus.PROGRESS]: GuideStatus.PROGRESS,
  },
  [GuideStatus.PROGRESS]: {
    [GuideStatus.COMPLETED]: GuideStatus.COMPLETED,
    [GuideStatus.NOT_STARTED]: GuideStatus.PROGRESS,
    [GuideStatus.PROGRESS]: GuideStatus.PROGRESS,
  },
};

const getNextGuideStatus = (
  currentGuideStatus: GuideStatus,
  suggestedGuideStatus: GuideStatus
): GuideStatus => nextGuideStatusStateMachine[currentGuideStatus][suggestedGuideStatus];

export default getNextGuideStatus;
